import foundationsColors from "../Foundations/colors";

const tokensColors = {
  primary: {
    light: {
      onstate: foundationsColors.neutral[0],
      lighter: foundationsColors.brand[100],
      light: foundationsColors.brand[300],
      base: foundationsColors.brand[600],
      dark: foundationsColors.brand[800],
      darker: foundationsColors.brand[950],
      "alpha-10": foundationsColors.alphas.brand["alpha-10"],
      "alpha-16": foundationsColors.alphas.brand["alpha-16"],
      "alpha-24": foundationsColors.alphas.brand["alpha-24"],
    },
  },
  neutrals: {
    static: {
      "static-black": foundationsColors.neutral[950],
      "static-white": foundationsColors.neutral[0],
    },
    text: {
      "white-0": foundationsColors.neutral[0],
      "disabled-300": foundationsColors.neutral[300],
      "soft-400": foundationsColors.neutral[400],
      "sub-600": foundationsColors.neutral[600],
      "strong-950": foundationsColors.neutral[950],
    },
    background: {
      "white-0": foundationsColors.neutral[0],
      "weak-50": foundationsColors.neutral[50],
      "soft-200": foundationsColors.neutral[200],
      "sub-300": foundationsColors.neutral[400],
      "intense-700": foundationsColors.neutral[700],
      "surface-800": foundationsColors.neutral[800],
      "strong-950": foundationsColors.neutral[950],
    },
    surface: {
      "surface-0": foundationsColors.neutral[0],
      "container-50": foundationsColors.neutral[50],
    },
    stroke: {
      "white-0": foundationsColors.neutral[0],
      "soft-200": foundationsColors.neutral[200],
      "sub-300": foundationsColors.neutral[300],
      "strong-950": foundationsColors.neutral[950],
    },
    icon: {
      "white-0": foundationsColors.neutral[0],
      "disabled-300": foundationsColors.neutral[300],
      "soft-400": foundationsColors.neutral[400],
      "sub-600": foundationsColors.neutral[600],
      "strong-950": foundationsColors.neutral[950],
    },
  },
  states: {
    information: {
      onstate: foundationsColors.neutral[0],
      lighter: foundationsColors.blue[50],
      light: foundationsColors.blue[200],
      base: foundationsColors.blue[500],
      dark: foundationsColors.blue[700],
      "alpha-10": foundationsColors.alphas.blue["alpha-10"],
      "alpha-16": foundationsColors.alphas.blue["alpha-16"],
    },
    warning: {
      onstate: foundationsColors.neutral[0],
      lighter: foundationsColors.yellow[50],
      light: foundationsColors.yellow[200],
      base: foundationsColors.yellow[500],
      dark: foundationsColors.yellow[700],
      "alpha-10": foundationsColors.alphas.yellow["alpha-10"],
      "alpha-16": foundationsColors.alphas.yellow["alpha-16"],
    },
    error: {
      onstate: foundationsColors.neutral[0],
      lighter: foundationsColors.red[50],
      light: foundationsColors.red[200],
      base: foundationsColors.red[500],
      dark: foundationsColors.red[700],
      "alpha-10": foundationsColors.alphas.red["alpha-10"],
      "alpha-16": foundationsColors.alphas.red["alpha-16"],
    },
    success: {
      onstate: foundationsColors.neutral[0],
      lighter: foundationsColors.green[50],
      light: foundationsColors.green[200],
      base: foundationsColors.green[500],
      dark: foundationsColors.green[700],
      "alpha-10": foundationsColors.alphas.green["alpha-10"],
      "alpha-16": foundationsColors.alphas.green["alpha-16"],
    },
  },
  miscellaneous: {
    overlay: "rgba(2, 13, 23, 0.24)",
  },
};

export default tokensColors;
